var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconSeoSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M2.25 3.74H11a1 1 0 0 0 0-2H1.58A1.54 1.54 0 0 0 0 3.24v3a1.54 1.54 0 0 0 1.58 1.5H11a1 1 0 0 0 0-2H2.25A.25.25 0 0 1 2 5.49V4a.25.25 0 0 1 .25-.26M21.41 7.24a.26.26 0 0 1 0-.3 4.18 4.18 0 1 0-1.71 1.67.26.26 0 0 1 .3 0L22.29 11a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Zm-3.71-.12a2.18 2.18 0 1 1 2.18-2.18 2.19 2.19 0 0 1-2.18 2.18"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 16.74,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 21.74,
  r: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 15.74H5a1 1 0 1 0 0 2h9.5a1 1 0 1 0 0-2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 11.74,
  r: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 10.74H5a1 1 0 0 0 0 2h9.5a1 1 0 0 0 0-2M14.5 20.74H5a1 1 0 0 0 0 2h9.5a1 1 0 0 0 0-2"
}))));
export default SvgStreamlineIconSeoSearch;